<template>
    <UserOverview />
</template>

<script setup>
import UserOverview from './UserOverview.vue';
</script>